import { render, staticRenderFns } from "./billConfirm.vue?vue&type=template&id=0ba288b8"
import script from "./billConfirm.vue?vue&type=script&lang=js"
export * from "./billConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports